module.exports = function getResource(label) {
    let resources = {
        reviews: 'commentaires'
    };
    return resources[label];
};
